import React, { useEffect, useState } from "react";
import { Button, Form, Spin, Modal, Popconfirm } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { PAGE_SIZE } from "../../constants";
import { Link } from "react-router-dom";
import {
	createAdmin,
	deleteAdmin,
	fetchAdmins,
	updateAdmin,
} from "../../actions/admin";
import AdminsTable from "../Tables/Admins";
import { ReactSVG } from "react-svg";
import AdminForm from "../Forms/Admin";

const AdminsPage = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [adminId, setAdminId] = useState(null);
	const { admins, status, loading } = useSelector((state) => state.fetchAdmins);
	const { status: updateStatus } = useSelector((state) => state.updateAdmin);
	const { adminDeleted } = useSelector((state) => state.deleteAdmin);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleClickDelete = (record) => {
		dispatch(deleteAdmin(record.id));
	};

	const handleAddAdmin = () => {
		showModal();
		setAdminId("");
		form.resetFields();
	};

	const handleEdit = (record) => {
		showModal();
		setAdminId(record.id);
		form.setFieldsValue(record);
	};

	const handleSubmitForm = (values) => {
		if (adminId) {
			dispatch(updateAdmin(adminId, values));
		} else {
			dispatch(createAdmin(values));
		}
		handleOk();
	};

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Link to={`/admins/${record.id}`}>
					<Button type="link" className="btn-table-action-primary">
						Show
					</Button>
				</Link>
				<Button
					type="link"
					className="btn-table-action-primary"
					onClick={() => handleEdit(record)}
				>
					Edit
				</Button>
				<Popconfirm
					title="Are you sure to delete this one?"
					onConfirm={() => handleClickDelete(record)}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" className="btn-table-action-danger">
						Delete
					</Button>
				</Popconfirm>
			</span>
		);
	};

	useEffect(() => {
		if (status === "IDLE")
			dispatch(fetchAdmins({ start: 0, count: PAGE_SIZE }));
	}, [status]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED")
			dispatch(fetchAdmins({ start: 0, count: PAGE_SIZE }));
	}, [updateStatus]);

	useEffect(() => {
		if (adminDeleted) {
			dispatch(fetchAdmins({ start: 0, count: PAGE_SIZE }));
		}
	}, [adminDeleted]);

	return (
		<div className="categories-container">
			<div className="page-header">
				<div className="page-header-breadbrumb">
					<ul>
						<li>Admins</li>
					</ul>
				</div>
				<div className="page-header-actions">
					<Button
						type="primary"
						className="btn btn-primary"
						onClick={handleAddAdmin}
					>
						New Admin
						<ReactSVG src="/icons/post-add.svg" />
					</Button>
				</div>
			</div>
			<div className="page-content">
				{status === "SUCCEEDED" && (
					<Spin spinning={loading}>
						<AdminsTable
							rowKey="id"
							pagination={false}
							dataSource={admins.data}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={150}
							withAction={withAction}
						/>
					</Spin>
				)}
			</div>
			<Modal
				className="topic-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<AdminForm
					form={form}
					adminId={adminId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default AdminsPage;
